'use strict';

import template from './template.html';


export default function() {
	return {
		scope: {
			user: '<',
			size: '<',
		},
		template: template,
		link: function(scope, element, attrs) {
			element.addClass('name-circle');
			scope.$watch('user', () => {
				const fullName = (scope.user.first_name + ' ' + scope.user.last_name).trim();
                const isAnonymous = fullName === '';
				scope.circleStyle = {
					display: 'block',
					width: scope.size,
					height: scope.size,
					'border-radius': Math.ceil(scope.size/2) + 'px',
					'text-align': 'center',
					'background-color': stringToColour(fullName),
					'color': 'white',
					'font-size': ((scope.size-2)/2) + 'px',
					'line-height': scope.size + 'px',
                    'font-weight': 600,
				};
                if (isAnonymous) {
                    scope.abbreviatedName = '?';
                    scope.circleStyle['background-color']
                    scope.circleStyle = Object.assign(scope.circleStyle, {
                        'background-color': 'white',
                        'color': '#777',
                        'border': '1px solid #ccc',
                    });
                } else {
                    scope.abbreviatedName = (
					    scope.user.first_name.substring(0,1)
                        + scope.user.last_name.substring(0,1)
                    );
                }
			});
		},
	};
}


function stringToColour(str) {
	var hash = 0;
	for (var i = 0; i < str.length; i++) {
		hash = str.charCodeAt(i) + ((hash << 5) - hash);
	}
	var colour = '#';
	for (var i = 0; i < 3; i++) {
		var value = (hash >> (i * 8)) & 0xFF;
		colour += ('00' + value.toString(16)).substr(-2);
	}
	return colour;
}
